<template>
  <div
    class="tw-w-[154px] tw-h-[52px] tw-flex tw-justify-center tw-items-center"
  >
    <img
      class="tw-relative tw-right-4 tw-h-full tw-w-auto"
      alt="site logo"
      :src="logoSrc"
      data-test-id="site-logo"
      data-clarity-mask="true"
    />
  </div>
</template>
<script lang="ts">
interface IProps {
  logoSrc: string;
}
</script>
<script setup lang="ts">
defineProps<IProps>();
</script>
